import React, { Component } from "react"
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
import classNames from "classnames"
import { trans, isRtl } from '@utils'
import './InputGroupButtonDropdown.scss'

class InputGroupButtonDropdown extends Component {

  constructor(props) {
    super(props)
    this.state = {
      open: false
    }
  }

  toggle = () => {
    this.setState((state) => {
      return {
        open: !state.open
      }
    })
  }

  onChange = (option) => {
    if (this.props.onChange) {
      this.props.onChange(option)
    }
  }

  render() {
    const { fullWidth = false, options } = this.props
    const { code, label, value } = this.props.value
    return (
      <ButtonDropdown direction={isRtl() ? 'right' : 'down'} isOpen={this.state.open} toggle={this.toggle}>
        <DropdownToggle className={classNames("input-group-button-dropdown-toggle", { "full-width": fullWidth })} color='primary' caret outline>
    			<span className="text-dark">{trans(label)}</span>
        </DropdownToggle>
        <DropdownMenu className="input-group-button-dropdown-menu">
          {_.map(options, (option) => (
            <DropdownItem key={option.code} className={classNames("d-flex align-items-center py-25 w-100", { "bg-primary text-white": code === option.code })} onClick={() => this.onChange(option)}> 
              <span className="font-small-3">{trans(option.label)}</span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </ButtonDropdown>
    )
  }
}

export default InputGroupButtonDropdown